export const LOADED = 'books/loaded';
export const ADDED = 'books/added';
export const UPDATED = 'books/updated';
export const IDADDED = 'books/idAdded';
export const DELETED = 'books/deleted';
export const FILTERED = 'books/filtered';
export const SEARCHED = 'books/searched';
